// auto close modal dialogs when they are css hidden on resize
export const hideOpenDialogOnResize = () =>
  window.addEventListener(
    'resize',
    () => {
      const screens = JSON.parse(getComputedStyle(document.documentElement).getPropertyValue('--screens') ?? '{}')
      const windowSize = window.innerWidth
      const classSelectors = []

      for (let screen in screens) {
        if (screens[screen] < windowSize) {
          classSelectors.push(`.\\${screen}\\:hidden`)
        }
      }

      if (classSelectors.length > 0) {
        const selector = `dialog[open]:is(${classSelectors.join(',')}):modal`
        const dialogs = Array.from(document.querySelectorAll(selector))
        dialogs.forEach((dialog) => dialog.close())
      }
    },
    { passive: true },
  )
